import React, { useEffect, useRef } from 'react';
import TiptapEditor from './TiptapEditor';
import { CATEGORIES } from '../../constants/categories';
import MultiImageUpload from './MultiImageUpload';

/**
 * Basic Information section component
 */
export const BasicInfoSection = ({ post, handleInputChange }) => {
  const textareaRef = useRef(null);
  
  // Function to adjust textarea height based on content
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };
  
  // Adjust height on initial render and when content changes
  useEffect(() => {
    adjustTextareaHeight();
  }, [post.excerpt]);

  return (
    <div className="form-section">
      <div className="section-title">Informasi Dasar</div>
      <div className="form-group">
        <label className="form-label">
          <span className="label-text">Judul <span className="required-indicator">*</span></span>
        </label>
        <input
          type="text"
          name="title"
          value={post.title}
          onChange={handleInputChange}
          className="form-input"
          required
          placeholder="Masukkan judul postingan"
        />
      </div>

      <div className="form-group">
        <label className="form-label">
          <span className="label-text">Ringkasan <span className="required-indicator">*</span></span>
        </label>
        <textarea
          ref={textareaRef}
          name="excerpt"
          value={post.excerpt}
          onChange={(e) => {
            handleInputChange(e);
            adjustTextareaHeight();
          }}
          className="form-input dynamic-textarea"
          required
          placeholder="Masukkan ringkasan postingan"
          rows="2"
        />
      </div>

      <div className="form-group">
        <label className="form-label">
          <span className="label-text">Kategori <span className="required-indicator">*</span></span>
        </label>
        <div className="radio-group">
          {Object.entries(CATEGORIES).map(([key, { label }]) => (
            <label key={key} className="radio-option">
              <input
                type="radio"
                name="category"
                value={key}
                checked={post.category ? post.category.toUpperCase() === key : key === 'BLOG'}
                onChange={handleInputChange}
                required
              />
              <span className="radio-label">{label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">
          <span className="label-text">Penulis</span>
        </label>
        <input
          type="text"
          name="author"
          value={post.author}
          onChange={handleInputChange}
          className="form-input"
          placeholder="Nama penulis"
        />
      </div>
    </div>
  );
};

/**
 * Content section component
 */
export const ContentSection = ({ content, handleContentChange }) => (
  <div className="form-section">
    <div className="section-title">Konten Artikel</div>
    <div className="form-group">
      <label className="form-label">
        <span className="label-text">Konten</span>
      </label>
      <div className="editor-container">
        <TiptapEditor
          value={content}
          onChange={handleContentChange}
        />
      </div>
    </div>
  </div>
);

/**
 * Media section component - Now supports multiple images
 */
export const MediaSection = ({ images = [], onImagesChange }) => (
  <div className="form-section">
    <div className="section-title">Media</div>
    <div className="form-group">
      <MultiImageUpload
        images={images}
        onChange={onImagesChange}
        maxImages={3}
        maxSizeKB={100}
      />
    </div>
  </div>
);

/**
 * Form buttons component
 */
export const FormButtons = ({ onCancel, onSubmit, isSubmitting }) => (
  <div className="form-buttons-container">
    <button
      type="button"
      onClick={onCancel}
      className="secondary-button"
      disabled={isSubmitting}
    >
      Batal
    </button>
    
    <div className="save-buttons-group">
      <button
        type="button"
        onClick={() => onSubmit('draft')}
        className="draft-button"
        disabled={isSubmitting}
      >
        Simpan sebagai Draft
      </button>
      
      <button
        type="button"
        onClick={() => onSubmit('published')}
        className="primary-button"
        disabled={isSubmitting}
      >
        Simpan dan Publikasikan
      </button>
    </div>
  </div>
);
